<template>
    <div>
        <div class="tool-bar mb10">
            <el-button type="primary" v-if="pageFuncNames.includes('add_team_rule')" @click="showAddModal"  size="mini" class="mr10">添加团队规则</el-button>
        </div>
        <div class="data-list">
            <el-table
                v-loading="dataLoading"
                :data="dataList"
                stripe
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :default-sort = "{prop: 'log_time', order: 'descending'}"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    label="规则ID"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="app_type"
                    label="产品类型"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.app_type=='1'">应用</span>
                        <span v-else-if="scope.row.app_type=='2'">游戏</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="game_classify"
                    label="游戏分类"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.game_classify=='3'">IAA</span>
                        <span v-else-if="scope.row.game_classify=='4'">IAP</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="素材类型"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type=='1'">图片</span>
                        <span v-else-if="scope.row.type=='2'">视频</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="group"
                    label="制作部门"
                    align="left"
                    min-width="150">
                    <template slot-scope="scope">
                        <p><span>{{(scope.row.group||[]).map(item=>item.name).filter(item=>!!item).join('、')}}</span></p>
                        <!--<p v-for="(item,index) in scope.row.group" :key="item.name+index">{{item.name}}</p>-->
                    </template>
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="创建人"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="ctime"
                    label="创建时间"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.ctime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="edit_name"
                    label="最新修改人"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="mtime"
                    label="最新修改时间"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.mtime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="action"
                    label="操作"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <div class="tac">
                            <el-button v-if="pageFuncNames.includes('edit_team_rule')" @click="editRow(scope.row)" type="text" class="text-color-primary mr10">编辑</el-button>
                            <el-popconfirm
                                title="您确定要删除吗？"
                                confirm-button-text="删除"
                                confirm-button-type="danger"
                                v-if="pageFuncNames.includes('delete_team_rule')"
                                @confirm="deleteRow(scope.row)">
                                <el-button slot="reference" :loading="scope.row.deleteLoading" type="text" class="text-color-error ml10">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import API from '@/api/workOrder/conf.js';
    import {teamRuleModal} from '../modal/index';

    export default {
        name: "TeamList",
        props:{
            pageFunc:Array,
        },
        data(){
            return {
                dataLoading:false,
                dataList:[],
            }
        },
        computed:{
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            showAddModal(){
                console.log('showAddModal');
                teamRuleModal({
                    props: {

                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：保存',data);
                            this.getDataList();
                        },
                        onEdit:(id,list)=>{
                            this.toEditRow(id,list);
                        },
                    }
                })
            },
            getDataList(){
                console.log('getTeamConfigList');
                this.dataLoading = true;
                API.getTeamConfigList().then(res=>{
                    console.log('getTeamConfigList',res);
                    this.dataLoading = false;
                    let resData = res.data||[];
                    this.dataList = resData.map(item=>{
                        item.deleteLoading = false;
                        return item;
                    });
                },err=>{
                    console.log('getTeamConfigList err',err)
                    this.dataLoading = false;
                })
            },
            toEditRow(id,list){
                console.log('toEditRow',id,list);
                teamRuleModal({
                    props: {
                        id:id,
                        detail:list,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：保存',data);
                            this.getDataList();
                        },
                    }
                })
            },
            editRow(row){
                console.log('editRow',row);
                teamRuleModal({
                    props: {
                        id:row.id,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：保存',data);
                            this.getDataList();
                        },
                    }
                })
            },
            deleteRow(row){
                console.log('deleteRow',row);
                row.deleteLoading = true;
                API.deleteTeamConfig({
                    id:row.id,
                }).then(res=>{
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                },err=>{
                    row.deleteLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'操作失败');
                })
            },
        },
    }
</script>

<style scoped>
.word-break {
    word-break:break-word;
}
</style>
